import { ObjectId } from "bson";

export function newId() {
  // Correct: Returning the value directly
  return new ObjectId().toHexString();
}